import { render, staticRenderFns } from "./deleteModal.vue?vue&type=template&id=38055074&scoped=true&"
import script from "./deleteModal.vue?vue&type=script&lang=js&"
export * from "./deleteModal.vue?vue&type=script&lang=js&"
import style0 from "./deleteModal.vue?vue&type=style&index=0&id=38055074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38055074",
  null
  
)

export default component.exports